<template>
    <PopupRouterView :showLeftIcon="true" label="Subcontract Good Receipt Input"
        okTitle="Save"
        cancelTitle="Cancel"
        entityName="subcontractgoodreceipt"
        :documentId="mainRecordId"
        @saveMethod="saveAction"
        @hideMethod="onHidden"
        ref="subcontractGoodReceiptInput"
        modalClass="input-scan-page">

        <template #modal-header-left-button>
			<span class="mr-1 d-sm-flex d-md-none">
                <b-button size="sm" class="ml-1 btn-back " @click="$router.back()"><b-icon-arrow-left /></b-button>
			</span>
		</template>

        <div class="p-2">
			<span v-if="scanPageIndex == 1">
				<b-row>
					<b-col cols="12">
						<app-input-scan id="fieldset-subcontract-request-delivery" ref="fieldset-subcontract-request-delivery" :model.sync="subcontractRequestDeliveryQrCode" label="Subcontract Request Delivery Number" @scannedMethod="scanSubcontractRequestDelivery" :isBusy="isScanSubcontractRequestDeliveryLoading" autofocus />
					</b-col>
				</b-row>
				<b-row>
					<b-col cols="12">
						<span v-if="subcontractRequestDeliverys != null && subcontractRequestDeliverys.length > 0">
							<app-list :isDataLoading="isSubcontractRequestDeliverySubcontractRequestDeliverysLoading" :dataCount="subcontractRequestDeliverys.length">
								<subcontract-request-delivery-item v-for="(item,index) in subcontractRequestDeliverys" @nextAction="scanSubcontractRequestDelivery(item.requestDeliveryNumber)" :model="item" :key="index" />
							</app-list>
						</span>
					</b-col>
				</b-row>
			</span>
			<span v-if="scanPageIndex == 2">
				<b-row>
					<b-col cols="12">
						<app-label v-if="parentValueInfo != undefined && parentValueInfo != null && parentValueInfo != ''" label-cols-lg="12" size="sm" :label="parentLabelInfo" :model="parentValueInfo" />
						<app-label label-cols-lg="12" size="sm" type="generatednumber" label="Subcontract Good Receipt Number" :model="model.subcontractGoodReceiptNumber" />
						<app-input-scan id="fieldset-surat-jalan" ref="fieldset-surat-jalan" :model.sync="suratJalanScanner" label="Surat Jalan" @scannedMethod="scanSuratJalan" :waitInputScan="waitInputSuratJalan" @clearMethod="clearMethodSuratJalan" autofocus />
						<app-input-textarea id="fieldset-remarks" label-cols-lg="12"  label="Remarks" label-for="input-remarks" size="sm" :model.sync="model.remarks"  @change="updateData" />
					</b-col>
				</b-row>
			</span>
			<span v-if="scanPageIndex == 3">
				<b-row>
					<b-col cols="12">
						<app-label v-if="parentValueInfo != undefined && parentValueInfo != null && parentValueInfo != ''" label-cols-lg="12" size="sm" :label="parentLabelInfo" :model="parentValueInfo" />
						<app-input-scan id="fieldset-control-card-scc" ref="fieldset-control-card-scc" :model.sync="sccCardQrCode" label="SCC" @scannedMethod="checkSCC" autofocus />
						<app-list :isDataLoading="isSubcontractRequestDeliverySubcontractRequestDeliverysLoading" :dataCount="controlCards.length">
							<scc-card-item v-for="(item, index) in controlCards" @nextAction="checkSCC" :model="item" :key="index" />
						</app-list>
					</b-col>
				</b-row>
				<b-row>
					<b-col cols="12">
						<span v-if="sccCards != null && sccCards.length > 0">
							<!-- <app-list :isDataLoading="isSCCCardLoading" :dataCount="sccCards.length"> -->
								<!-- nextmethod later -->
								<!-- <scc-card-item v-for="(item,index) in sccCards" :model="item" :key="index" /> -->
							<!-- </app-list> -->
						</span>
					</b-col>
				</b-row>
			</span>
			<span v-if="scanPageIndex == 4">
				 <b-row>
					<b-col cols="12">
						<app-label v-if="parentValueInfo != undefined && parentValueInfo != null && parentValueInfo != ''" label-cols-lg="12" size="sm" :label="parentLabelInfo" :model="parentValueInfo" />
						<app-label label-cols-lg="12" size="sm" label="Control Card" :model="selectedSccCard.controlCardNumber" />
						<app-label label-cols-lg="12" size="sm" label="Case Qty" :model="selectedSccCard.qtyCase" />
						<app-input-scan id="fieldset-control-card-pcc" ref="fieldset-control-card-pcc" :model.sync="pccCardQrCode" label="Bahan Baku" @scannedMethod="switchCard" :disabled="isQtyFulfilled" autofocus />
						<div v-for="(item, index) in subcontractGoodReceiptSuggestionDetails" :key="index" :class="getClasses(item)">
							<div>{{ item.controlCard.controlCardNumber }}</div>
							<div>{{ item.usedQty }}</div>
						</div>
					</b-col>
				 </b-row>
			</span>

        </div>


        <b-overlay :show="isBusy" no-wrap></b-overlay>
        <template #modal-action-button>
			<!-- <b-button v-if="scanPageIndex == 1" size="sm" class="btn-fill-success float-right" @click="goToNext(2)">Next</b-button> -->
			<!-- <b-button v-if="scanPageIndex == 3" size="sm" class="btn-fill-success float-right" @click="saveAction()">Finish</b-button> -->
			<b-button v-if="scanPageIndex == 2" @click="goToNext(1)" size="sm" class="btn-fill-success float-right">Back</b-button>
			<b-button v-if="scanPageIndex == 2" size="sm" class="btn-fill-success float-right" @click="saveDataToSavedState">Next</b-button>
			<b-button v-if="scanPageIndex == 3" @click="goToNext(2, 'back')" size="sm" class="btn-fill-success float-right">Back</b-button>
			<b-button v-if="scanPageIndex == 4" @click="goToNext(3, 'back')" size="sm" class="btn-fill-success float-right">Back</b-button>
			<b-button v-if="scanPageIndex == 4" size="sm" class="btn-fill-success float-right" @click="FinishSubconGR">Finish</b-button>
			<!-- <b-button @click="previewPage(true)" variant="primary">next</b-button> -->
        </template>
		<SubcontractGoodReceiptDetailScan
			:parentLabelInfo="parentLabelInfo"
			:parentValueInfo="parentValueInfo"
			:model="modelSubcontractGoodReceiptDetail"
			:modelId="subcontractGoodReceiptDetailId"
			:openPopup="isShowPopupSubcontractGoodReceiptDetail"
			@resetMethod="resetModal"
			@addButtonMethod="addRowDataSubcontractGoodReceiptDetail"/>
		<SubcontractGoodReceiptSuggestionDetailScan
			:parentLabelInfo="parentLabelInfo"
			:parentValueInfo="parentValueInfo"
			:model="modelSubcontractGoodReceiptSuggestionDetail"
			:modelId="subcontractGoodReceiptSuggestionDetailId"
			:openPopup="isShowPopupSubcontractGoodReceiptSuggestionDetail"
			@resetMethod="resetModal"
			@addButtonMethod="addRowDataSubcontractGoodReceiptSuggestionDetail"/>

    </PopupRouterView>
</template>

<style scoped>
	.list-bahan-baku {
		margin-top: 10px;
		display: flex;
		justify-content: space-between;
		font-size: 24px;
		padding: 3px 5px;
		border-radius: 10px;
	}
	.isScanned {
		background-color: rgb(68, 250, 68);
	}
</style>

<script>
import axios from 'axios';
import { validationMixin } from "vuelidate";
import { required, minLength } from "vuelidate/lib/validators";
import toast from '@/mixins/toastMixin';
import focusInput from '@/mixins/focusInputMixin';
import AppInputScan from '@/components/AppInputScan';
import AppList from '@/components/AppList';
import SubcontractGoodReceipt from '@/models/SubcontractGoodReceipt/SubcontractGoodReceipt';
import SubcontractGoodReceiptFilter from '@/filters/SubcontractGoodReceipt/SubcontractGoodReceiptFilter';
import SubcontractRequestDeliveryItem from './components/SubcontractRequestDeliveryItem';
import SccCardItem from './components/SccCardItem';
import AppLabel from '@/components/AppLabel';
import SubcontractRequestDelivery from '@/models/SubcontractRequestDelivery/SubcontractRequestDelivery';
import SubcontractRequestDeliveryFilter from '@/filters/SubcontractRequestDelivery/SubcontractRequestDeliveryFilter';
import DocumentStatus from '@/models/DocumentStatus/DocumentStatus';
import DocumentStatusFilter from '@/filters/DocumentStatus/DocumentStatusFilter';
import AppInputTextarea from '@/components/AppInputTextarea';
import SubcontractGoodReceiptDetail from '@/models/SubcontractGoodReceipt/SubcontractGoodReceiptDetail';
import SubcontractGoodReceiptDetailFilter from '@/filters/SubcontractGoodReceipt/SubcontractGoodReceiptDetailFilter';
import SubcontractGoodReceiptSuggestionDetail from '@/models/SubcontractGoodReceipt/SubcontractGoodReceiptSuggestionDetail';
import SubcontractGoodReceiptSuggestionDetailFilter from '@/filters/SubcontractGoodReceipt/SubcontractGoodReceiptSuggestionDetailFilter';
import ControlCard from '@/models/ControlCard/ControlCard';
import ControlCardFilter from '@/filters/ControlCard/ControlCardFilter';
import SubcontractGoodReceiptDetailScan from '@/views/SubcontractGoodReceipt/SubcontractGoodReceiptDetailScan';
import SubcontractGoodReceiptSuggestionDetailScan from '@/views/SubcontractGoodReceipt/SubcontractGoodReceiptSuggestionDetailScan';
import PopupRouterView from '@/components/PopupRouterView';
export default {
	components : {
		AppLabel,
		AppInputTextarea,
		SubcontractGoodReceiptDetailScan,
		SubcontractGoodReceiptSuggestionDetailScan,
		PopupRouterView,
		AppInputScan,
		AppList,
		SubcontractRequestDeliveryItem,
		SccCardItem,
	},
	mixins : [validationMixin, toast, focusInput],
	validations: {
		model: {
		},
	},
	data() {
		return {
			errorMessage : {
			},
			datas: Array(),
			selectAll:false,
			sortBy: '',
			sortDesc: '',
			pagingOptions:[
				{ value : '10', text : '10', selected:true },
				{ value : '25', text : '25' },
				{ value : '50', text : '50' },
				{ value : '100', text : '100' },
			],
			fieldsSubcontractGoodReceiptDetail: [
				{"frontActions": { "class" : "th-actions", "label" : ""}},
				{"no" : { "class" : "th-number d-stack-none"}}, 
				{"controlCard": { "class" : "th-control-card first-child", "label" : "Control Card", key: 'controlCard.controlCardNumber', sortable: false}}, 
				{"isComplete": { "class" : "th-is-complete", "label" : "Is Complete", key: 'isComplete', sortable: false}}, 
				{"caseQty": { "class" : "th-case-qty last-child", "label" : "Case Qty", key: 'caseQty', sortable: false}}, 
				{"actions": { "class" : "th-actions d-stack-show", "label" : ""}}
			],
			fieldsSubcontractGoodReceiptSuggestionDetail: [
				{"frontActions": { "class" : "th-actions", "label" : ""}},
				{"no" : { "class" : "th-number d-stack-none"}}, 
				{"controlCard": { "class" : "th-control-card first-child", "label" : "Control Card", key: 'controlCard.controlCardNumber', sortable: false}}, 
				{"caseQty": { "class" : "th-case-qty", "label" : "Case Qty", key: 'caseQty', sortable: false}}, 
				{"usedQty": { "class" : "th-used-qty last-child", "label" : "Used Qty", key: 'usedQty', sortable: false}}, 
				{"isScanned": { "class" : "th-is-scanned d-stack-none", "label" : "Is Scanned", key: 'isScanned', sortable: false}}, 
				{"actions": { "class" : "th-actions d-stack-show", "label" : ""}}
			],
			busy:false,
			isBusy: false,
			isDataLoading: false,
			selected:'',
			pageSizeOptions: 10,
			pageIndex:0,
			sortingBy: Array(),
			modelId: null,
			model: {},
			modelSubcontractGoodReceiptDetail : {},
			isShowPopupSubcontractGoodReceiptDetail : false,
			isShowPopupUploadSubcontractGoodReceiptDetail : false,
			isShowPopupSubcontractGoodReceiptDetailScan : false,
			modelSubcontractGoodReceiptSuggestionDetail : {},
			isShowPopupSubcontractGoodReceiptSuggestionDetail : false,
			isShowPopupUploadSubcontractGoodReceiptSuggestionDetail : false,
			isShowPopupSubcontractGoodReceiptSuggestionDetailScan : false,
			filterSubcontractGoodReceipt : null,
			currentSubcontractGoodReceiptPage : 1,
			subcontractGoodReceiptPageSize: 10,
			sortBySubcontractGoodReceipt: '',
			sortDescSubcontractGoodReceipt: '',
			filterSubcontractGoodReceiptDetail : null,
			currentSubcontractGoodReceiptDetailPage : 1,
			subcontractGoodReceiptDetailPageSize: 10,
			sortBySubcontractGoodReceiptDetail: '',
			sortDescSubcontractGoodReceiptDetail: '',
			sortingBySubcontractGoodReceiptDetail: [],
			subcontractGoodReceiptDetails : [],
			subcontractGoodReceiptDetailId : '',
			totalSubcontractGoodReceiptDetailRow : 0,
			isShowSubcontractGoodReceiptDetailFilter: false,
			isDownloadSubcontractGoodReceiptDetail: false,
			filterSubcontractGoodReceiptSuggestionDetail : {},
			currentSubcontractGoodReceiptSuggestionDetailPage : 1,
			subcontractGoodReceiptSuggestionDetailPageSize: 10,
			sortBySubcontractGoodReceiptSuggestionDetail: '',
			sortDescSubcontractGoodReceiptSuggestionDetail: '',
			sortingBySubcontractGoodReceiptSuggestionDetail: [],
			subcontractGoodReceiptSuggestionDetails : [],
			subcontractGoodReceiptSuggestionDetailId : '',
			totalSubcontractGoodReceiptSuggestionDetailRow : 0,
			isShowSubcontractGoodReceiptSuggestionDetailFilter: false,
			isDownloadSubcontractGoodReceiptSuggestionDetail: false,
			controlCards: [],
			subcontractRequestDeliverys: [],
			isSubcontractRequestDeliveryComboLoading: false,
			documentStatuss: [],
			isDocumentStatusComboLoading: false,
			isShowPopupConfirmation : false,
			isDataCommited : false,
			mainRecordId : '',
			isSubcontractGoodReceiptComboLoading: false,
			isControlCardComboLoading: false,
			isSubcontractGoodReceiptDetailComboLoading: false,
			scanPageIndex: 1,
			parentLabelInfo: '',
			parentValueInfo: '',
			subcontractRequestDeliveryQrCode: '',
			isScanSubcontractRequestDeliveryLoading: false,
			isSubcontractRequestDeliverySubcontractRequestDeliverysLoading: false,
			subcontractRequestDeliverySubcontractRequestDeliverys: [],
			subcontractRequestDeliverysFiltered: [],
			sccCards: [],
			isSCCCardLoading: false,
			selectedDetail: {},
			selectedControlCard: {},
			sccCardQrCode: '',
			pccCardQrCode: '',
			subcontractRequestDelivery: {},
			waitInputSuratJalan: false,
			suratJalanScanner: '',
			isQtyFulfilled: false,
		}
	},
	methods : {
		getClasses(data) {
			let classes = 'list-bahan-baku';
			if(data != null && data.isScanned == true) {
				classes += ' isScanned';
			}
			return classes;
		},
		clearMethodSuratJalan() {
			this.suratJalanScanner = '';
			this.waitInputSuratJalan = false;
			//this.updateData();
		},
		getSubcontractGoodReceipt : async function(id) {
			this.isBusy = true;
			await SubcontractGoodReceipt.getData(this, id).then(result => {
				this.model = result;
				this.mainRecordId = String(result.mainRecordId);
				let promises = Array();

				Promise.all(promises).then((results) => {
					this.isBusy = false;
				});
			}).catch(error => { this.isBusy = false; });
		},
		getSubcontractRequestDelivery : async function(id) {
			this.isBusy = true;
			await SubcontractRequestDelivery.getData(this, id).then(result => {
				this.subcontractRequestDelivery = result;	
				this.mainRecordId = String(result.mainRecordId);
				let promises = Array();

				Promise.all(promises).then((results) => {
					this.isBusy = false;
				});
			}).catch(error => { this.isBusy = false; });
		},
		downloadData() {
			this.isDownloadSubcontractGoodReceipt = true;
			this.filterSubcontractGoodReceipt.id = this.modelId;
			SubcontractGoodReceipt.downloadDataDetail(this, this.filterSubcontractGoodReceipt).then(result => {
				this.isDownloadSubcontractGoodReceipt = false;
			}).catch(error => { this.isDownloadSubcontractGoodReceipt = false; })
		},
		getSubcontractGoodReceiptDetails : async function(isAddRow) {
			let filter = {};
			Object.assign(filter, this.filterSubcontractGoodReceiptDetail);
			if (this.modelId == null) return;
			filter.subcontractGoodReceiptId = this.modelId;
			filter.draftMode = "1";
			if (this.sortBySubcontractGoodReceiptDetail != null) {
				this.sortingBySubcontractGoodReceiptDetail[this.sortBySubcontractGoodReceiptDetail] = this.sortDescSubcontractGoodReceiptDetail;
			}
			let currentPage = (this.currentSubcontractGoodReceiptDetailPage - 1);
			if (isAddRow) {
				let totalData = this.totalSubcontractGoodReceiptDetailRow + 1;
				let page = Math.ceil(totalData/this.subcontractGoodReceiptDetailPageSize);
				currentPage = page - 1;
			}
			// disable paging start
			currentPage = null;
			this.subcontractGoodReceiptDetailPageSize = 0;
			// disable paging end
			SubcontractGoodReceiptDetail.getList(this, filter, this.sortingBySubcontractGoodReceiptDetail, currentPage , this.subcontractGoodReceiptDetailPageSize).then(result => {
				this.currentSubcontractGoodReceiptDetailPage = currentPage + 1;
				this.subcontractGoodReceiptDetails = result.data.filter(obj =>
					Object.prototype.hasOwnProperty.call(obj, 'isScanned') && (obj.isScanned == false || obj.isScanned == null || obj.isScanned == undefined)
					);
				this.subcontractGoodReceiptDetailsFiltered = result.data.filter(obj =>
					Object.prototype.hasOwnProperty.call(obj, 'isScanned') && (obj.isScanned == true)
					);
				this.totalSubcontractGoodReceiptDetailRow = result.dataCount;
			}).catch(error => {});
		},
		getSubcontractGoodReceiptSuggestionDetails : async function(isAddRow) {
			let filter = {};
			Object.assign(filter, this.filterSubcontractGoodReceiptSuggestionDetail);
			if (this.modelId == null) return;
			filter.subcontractGoodReceiptId = this.modelId;
			filter.draftMode = "2";

			if(this.selectedDetail) {
				filter.subcontractGoodReceiptDetailId = this.selectedDetail.id;
			}

			if (this.sortBySubcontractGoodReceiptSuggestionDetail != null) {
				this.sortingBySubcontractGoodReceiptSuggestionDetail[this.sortBySubcontractGoodReceiptSuggestionDetail] = this.sortDescSubcontractGoodReceiptSuggestionDetail;
			}
			let currentPage = (this.currentSubcontractGoodReceiptSuggestionDetailPage - 1);
			if (isAddRow) {
				let totalData = this.totalSubcontractGoodReceiptSuggestionDetailRow + 1;
				let page = Math.ceil(totalData/this.subcontractGoodReceiptSuggestionDetailPageSize);
				currentPage = page - 1;
			}
			// disable paging start
			currentPage = null;
			this.subcontractGoodReceiptSuggestionDetailPageSize = 0;
			// disable paging end
			await SubcontractGoodReceiptSuggestionDetail.getList(this, filter, this.sortingBySubcontractGoodReceiptSuggestionDetail, currentPage , this.subcontractGoodReceiptSuggestionDetailPageSize).then(result => {
				this.currentSubcontractGoodReceiptSuggestionDetailPage = currentPage + 1;

				console.log("filter suggestion detail", filter);
				console.log("result api suggestion detail", result);

				this.subcontractGoodReceiptSuggestionDetails = result.data;
				if(result.data != null && result.data.length > 0) {
					let sumQty = 0;
					for (let index = 0; index < result.data.length; index++) {
						const element = result.data[index];
						if(element != null && element.isScanned == true) {
							sumQty += element.usedQty;
						}
						
					}
					if(this.selectedSccCard != null && sumQty == this.selectedSccCard.qtyCase) {
						this.isQtyFulfilled = true;
					}
				}
				this.totalSubcontractGoodReceiptSuggestionDetailRow = result.dataCount;
			}).catch(error => {});
		},
		getSubcontractGoodReceipts : async function(input) {
			let filter = new SubcontractGoodReceiptFilter();
			if (input != undefined) {
				filter.SubcontractGoodReceiptNumber = input;
			}
			this.isSubcontractGoodReceiptComboLoading = true;
			await SubcontractGoodReceipt.getList(this, filter, null, 0, 10)
			.then(result => {
				if (result != null) {
					this.subcontractGoodReceipts = result.data
				}
				this.isSubcontractGoodReceiptComboLoading = false;
			})
			.catch(error => {});
		},
		getControlCards : async function(input) {
			let filter = new ControlCardFilter();
			if(input != null) {
				filter.controlCardNumber = input;
			}
			let partIds = this.subcontractRequestDelivery.subcontractRequestDeliveryDetail.map(detail => detail.partId);
			let controlCardIds = this.model.subcontractGoodReceiptDetail.filter(detail => !detail.isComplete).map(detail => detail.controlCardId);
			filter.partId = partIds.join(",");
			filter.id = controlCardIds.join(",");
			filter.transactionType = "SUBCONT_REQUEST_DELIVERY_DETAIL"
			
			this.isControlCardComboLoading = true;
			await ControlCard.getList(this, filter, null, 0, 10)
			.then(result => {
				if (result != null) {
					this.controlCards = result.data
				}
				this.isControlCardComboLoading = false;
			})
			.catch(error => {});
		},
		getSubcontractRequestDeliverys : async function(input) {
			let filter = new SubcontractRequestDeliveryFilter();
			if (input != undefined) {
				filter.requestDeliveryNumber = input;
			}
			filter.documentStatusId = "OPEN,IN_PROGRESS";
			await SubcontractRequestDelivery.getList(this, filter, null, 0, 10)
			.then(result => {
				if (result != null) {
					this.subcontractRequestDeliverys = result.data
				}
			})
			.catch(error => {});
		},
		setSelectedSubcontractRequestDelivery(item) {
			if(item == undefined || item == null) {
				this.model.subcontractRequestDeliveryId = null;
				this.model.subcontractRequestDelivery = null;
			} else {
				this.model.subcontractRequestDeliveryId = item.id;
				this.model.subcontractRequestDelivery = item;
			}
			this.$forceUpdate();
			this.updateData();
		},
		getDocumentStatuss : async function(input) {
			let filter = new DocumentStatusFilter();
			if (input != undefined) {
				filter.name = input;
			}
			await DocumentStatus.getList(this, filter, null, 0, 10)
			.then(result => {
				if (result != null) {
					this.documentStatuss = result.data
				}
			})
			.catch(error => {});
		},
		setSelectedDocumentStatus(item) {
			if(item == undefined || item == null) {
				this.model.documentStatusId = null;
				this.model.documentStatus = null;
			} else {
				this.model.documentStatusId = item.id;
				this.model.documentStatus = item;
			}
			this.$forceUpdate();
			this.updateData();
		},
		validateState(name) {
			if (!this.$v.model[name]) return null;
			const { $dirty, $error } = this.$v.model[name];
			return $dirty ? !$error : null;
		},
		getErrorMessage(message, name) {
			if (!this.$v.model[name]) return "";
			if (this.$v.model[name].required != undefined && !this.$v.model[name].required) {
				if (message.required) return message.required;
			}
		},
		handleScroll() {
			this.$refs.subcontractGoodReceiptInput.scrollTop = 0;
		},
		saveAction(modalEvent) {
			if (modalEvent != undefined && modalEvent != null) {
				modalEvent.preventDefault();
			}
			let id = this.$route.params.id;
			this.$v.model.$touch(); 
			if (this.$v.model.$anyError) {
				return;
			} else {
				this.isBusy = true;
				let id = this.modelId;
				let model = this.model;

				if (id != '' && id != null && id != undefined) {
					SubcontractGoodReceipt.commitData(this, model, id).then(result => {
						this.isDataCommited = true;
						this.$router.push({ name: 'subcontractgoodreceiptindex' });
						this.isBusy = false;
					}).catch(error => { this.isBusy = false; });
				} else {
					SubcontractGoodReceipt.insertData(this, model).then(result => {
						this.isDataCommited = true;
						this.$router.push({ name: 'subcontractgoodreceiptindex' });
						this.isBusy = false;
					}).catch(error => { this.isBusy = false; });
				}
			}
		},
		updateData() {
			let id = this.modelId;
			let model = this.model;
			let promises = Array();

			if(model.suratJalan) this.waitInputSuratJalan = true;

			return Promise.all(promises).then((results) => {
				if (id != '' && id != null && id != undefined) {
					return SubcontractGoodReceipt.updateData(this, model, id)
					.catch((error) => {
						return this.getSubcontractGoodReceipt(id);
					});
				}
				return false;
			});
		},
		onHidden() {
			this.getSubcontractGoodReceipts();
		},
		addRowDataSubcontractGoodReceiptDetail(modalEvent, model) {
			if (model != null) {
				model.isScanned = true;
				if (model.id != null && model.id != '') {
					model.subcontractGoodReceiptId =  this.modelId;
					SubcontractGoodReceiptDetail.updateDataDetail(this, model, model.id)
					.then(result => {
						this.getSubcontractGoodReceiptDetails(true);
						this.isShowPopupSubcontractGoodReceiptDetail = false;
					})
				} else {
					model.subcontractGoodReceiptId =  this.modelId;
					SubcontractGoodReceiptDetail.createDataDetail(this, model)
					.then(result => {
						this.getSubcontractGoodReceiptDetails(true);
						this.isShowPopupSubcontractGoodReceiptDetail = false;
					})
				}
			}
		},
		async editRowDataSubcontractGoodReceiptDetail(id) {
			this.subcontractGoodReceiptDetailId = id;
			this.isShowPopupSubcontractGoodReceiptDetail = true; 
		},
		async deleteRowDataSubcontractGoodReceiptDetail(id) {
			SubcontractGoodReceiptDetail.deleteData(this, id).then(result => { this.getSubcontractGoodReceiptDetails(); });
		},
		async resetDataSubcontractGoodReceiptDetail() {
			this.subcontractGoodReceiptDetailId = "";
			this.isShowPopupSubcontractGoodReceiptDetail = true;
		},
		async addDataSubcontractGoodReceiptDetail() {
			SubcontractGoodReceiptDetail.createData(this, { subcontractGoodReceiptId: this.modelId })
			.then(result => {
				this.getSubcontractGoodReceiptDetails(true);
			})
		},
		async addFromClipboardSubcontractGoodReceiptDetail() {
			let controlCards = new Array();
			navigator.clipboard.readText().then(value => {
				if(value.match(/(?:\r\n|\r|\n)/g)) { value=value.replace(/(?:\r\n|\r|\n)/g, ',') ; }
				let values = value.split(",");
				values.forEach(item => {
					controlCards.push({ controlCard: item, subcontractGoodReceiptId: this.modelId });
				});
				SubcontractGoodReceiptDetail.addFromClipboard(this, controlCards).then(result => { this.getSubcontractGoodReceiptDetails() });
			});
		},
		async replaceFromClipboardSubcontractGoodReceiptDetail() {
			let controlCards = new Array();
			navigator.clipboard.readText().then(value => {
				if(value.match(/(?:\r\n|\r|\n)/g)) { value=value.replace(/(?:\r\n|\r|\n)/g, ',') ; }
				let values = value.split(",");
				values.forEach(item => {
					controlCards.push({ controlCard: item, subcontractGoodReceiptId: this.modelId });
				});
				SubcontractGoodReceiptDetail.replaceFromClipboard(this, controlCards).then(result => { this.getSubcontractGoodReceiptDetails() });
			});   
		},
		showPopupUploadSubcontractGoodReceiptDetail() {
			this.isShowPopupUploadSubcontractGoodReceiptDetail = true;
		},
		uploadDataSubcontractGoodReceiptDetail(modalEvent, newDatas) {
			this.isShowPopupUploadSubcontractGoodReceiptDetail = false; 
		},
		downloadSubcontractGoodReceiptDetail(modalEvent) {
			this.isDownloadSubcontractGoodReceiptDetail = true;
			this.filterSubcontractGoodReceiptDetail.subcontractGoodReceiptId = this.modelId;
			SubcontractGoodReceiptDetail.downloadDataDetail(this, this.filterSubcontractGoodReceiptDetail).then(result => {
				this.isDownloadSubcontractGoodReceiptDetail = false;
			}).catch(error => { this.isDownloadSubcontractGoodReceiptDetail = false; })
		},
		saveInputSubcontractGoodReceiptDetail(item) {
			if (this.subcontractGoodReceipts != null && this.subcontractGoodReceipts != undefined  && this.subcontractGoodReceipts.length > 0) {
				item.subcontractGoodReceipt = this.subcontractGoodReceipts.find(q => q.id == item.subcontractGoodReceiptId);
			}
			if (this.controlCards != null && this.controlCards != undefined  && this.controlCards.length > 0) {
				item.controlCard = this.controlCards.find(q => q.id == item.controlCardId);
			}

			let id = item.id;
			let promises = Array();

			Promise.all(promises).then((results) => {
				if (id != '' && id != null && id != undefined) {
					SubcontractGoodReceiptDetail.updateData(this, item, item.id);
				}
			});
		},
		addRowDataSubcontractGoodReceiptSuggestionDetail(modalEvent, model) {
			if (model != null) {
				model.isScanned = true;
				if (model.id != null && model.id != '') {
					model.subcontractGoodReceiptId =  this.modelId;
					SubcontractGoodReceiptSuggestionDetail.updateDataDetail(this, model, model.id)
					.then(result => {
						this.getSubcontractGoodReceiptSuggestionDetails(true);
						this.isShowPopupSubcontractGoodReceiptSuggestionDetail = false;
					})
				} else {
					model.subcontractGoodReceiptId =  this.modelId;
					SubcontractGoodReceiptSuggestionDetail.createDataDetail(this, model)
					.then(result => {
						this.getSubcontractGoodReceiptSuggestionDetails(true);
						this.isShowPopupSubcontractGoodReceiptSuggestionDetail = false;
					})
				}
			}
		},
		async editRowDataSubcontractGoodReceiptSuggestionDetail(id) {
			this.subcontractGoodReceiptSuggestionDetailId = id;
			this.isShowPopupSubcontractGoodReceiptSuggestionDetail = true; 
		},
		async deleteRowDataSubcontractGoodReceiptSuggestionDetail(id) {
			SubcontractGoodReceiptSuggestionDetail.deleteData(this, id).then(result => { this.getSubcontractGoodReceiptSuggestionDetails(); });
		},
		async resetDataSubcontractGoodReceiptSuggestionDetail() {
			this.subcontractGoodReceiptSuggestionDetailId = "";
			this.isShowPopupSubcontractGoodReceiptSuggestionDetail = true;
		},
		async addDataSubcontractGoodReceiptSuggestionDetail() {
			SubcontractGoodReceiptSuggestionDetail.createData(this, { subcontractGoodReceiptId: this.modelId })
			.then(result => {
				this.getSubcontractGoodReceiptSuggestionDetails(true);
			})
		},
		async addFromClipboardSubcontractGoodReceiptSuggestionDetail() {
			let controlCards = new Array();
			navigator.clipboard.readText().then(value => {
				if(value.match(/(?:\r\n|\r|\n)/g)) { value=value.replace(/(?:\r\n|\r|\n)/g, ',') ; }
				let values = value.split(",");
				values.forEach(item => {
					controlCards.push({ controlCard: item, subcontractGoodReceiptId: this.modelId });
				});
				SubcontractGoodReceiptSuggestionDetail.addFromClipboard(this, controlCards).then(result => { this.getSubcontractGoodReceiptSuggestionDetails() });
			});
		},
		async replaceFromClipboardSubcontractGoodReceiptSuggestionDetail() {
			let controlCards = new Array();
			navigator.clipboard.readText().then(value => {
				if(value.match(/(?:\r\n|\r|\n)/g)) { value=value.replace(/(?:\r\n|\r|\n)/g, ',') ; }
				let values = value.split(",");
				values.forEach(item => {
					controlCards.push({ controlCard: item, subcontractGoodReceiptId: this.modelId });
				});
				SubcontractGoodReceiptSuggestionDetail.replaceFromClipboard(this, controlCards).then(result => { this.getSubcontractGoodReceiptSuggestionDetails() });
			});   
		},
		showPopupUploadSubcontractGoodReceiptSuggestionDetail() {
			this.isShowPopupUploadSubcontractGoodReceiptSuggestionDetail = true;
		},
		uploadDataSubcontractGoodReceiptSuggestionDetail(modalEvent, newDatas) {
			this.isShowPopupUploadSubcontractGoodReceiptSuggestionDetail = false; 
		},
		downloadSubcontractGoodReceiptSuggestionDetail(modalEvent) {
			this.isDownloadSubcontractGoodReceiptSuggestionDetail = true;
			this.filterSubcontractGoodReceiptSuggestionDetail.subcontractGoodReceiptId = this.modelId;
			SubcontractGoodReceiptSuggestionDetail.downloadDataDetail(this, this.filterSubcontractGoodReceiptSuggestionDetail).then(result => {
				this.isDownloadSubcontractGoodReceiptSuggestionDetail = false;
			}).catch(error => { this.isDownloadSubcontractGoodReceiptSuggestionDetail = false; })
		},
		saveInputSubcontractGoodReceiptSuggestionDetail(item) {
			if (this.subcontractGoodReceiptDetails != null && this.subcontractGoodReceiptDetails != undefined  && this.subcontractGoodReceiptDetails.length > 0) {
				item.subcontractGoodReceiptDetail = this.subcontractGoodReceiptDetails.find(q => q.id == item.subcontractGoodReceiptDetailId);
			}

			let id = item.id;
			let promises = Array();

			Promise.all(promises).then((results) => {
				if (id != '' && id != null && id != undefined) {
					SubcontractGoodReceiptSuggestionDetail.updateData(this, item, item.id);
				}
			});
		},
		resetModal(modalType) {
			this.isShowPopupUploadSubcontractGoodReceiptDetail = false; 
			this.isShowPopupSubcontractGoodReceiptDetail = false; 
			if (modalType == 'SubcontractGoodReceiptDetail') {
				this.getSubcontractGoodReceiptDetails();
			}
			this.isShowPopupUploadSubcontractGoodReceiptSuggestionDetail = false; 
			this.isShowPopupSubcontractGoodReceiptSuggestionDetail = false; 
			if (modalType == 'SubcontractGoodReceiptSuggestionDetail') {
				this.getSubcontractGoodReceiptSuggestionDetails();
			}
			this.subcontractRequestDeliveryQrCode = '';
			this.showPopupCopyData = false; 
			this.isShowPopupConfirmation = false;
			this.getSubcontractGoodReceipts();
		},
		displayFilter() {
			this.windowWidth = window.innerWidth;
		},
		async scanSubcontractRequestDelivery(paramQr) {
			try {
				if(paramQr)  {
					this.subcontractRequestDeliveryQrCode = paramQr;
				}

				let qrCode = encodeURIComponent(this.subcontractRequestDeliveryQrCode);
				let id = this.model.id;

				let response = await this.$http.get(`SubcontractGoodReceipt/ScanSubcontractRequestDelivery/${id}?qrcode=${qrCode}`);	
				if (response && response.data) {
					let result = response.data;

					this.parentLabelInfo = "Subcontract Request Delivery";
					this.parentValueInfo = this.subcontractRequestDeliveryQrCode;
					this.subcontractRequestDeliveryQrCode = '';
					await this.getSubcontractGoodReceipt(id);
		
					if(result.dataExist == true) {
						let id = result.id;
						this.modelId = id;
									
						await this.getSubcontractGoodReceipt(this.modelId);
						if(this.model.suratJalan) {
							this.suratJalanScanner = this.model.suratJalan;

						}

						if(this.$route.path == '/subcontractgoodreceipt/scan/' + id) {
							this.goToNext(2);
							return;
						}
						this.$router.replace('/subcontractgoodreceipt/scan/' + id, () => {
							this.goToNext(2);
							return;
						});
					} else {
						this.goToNext(2);
					}
				}
			} catch(error) {
				this.subcontractRequestDeliveryQrCode = '';
				let errors = error.response.data.errors['1']
				this.toast({message: errors[0], title: 'System Error', variant: 'danger', autoHideDelay: 3000})
				this.$nextTick(() => {
					this.focusInput(this, "fieldset-subcontract-request-delivery");
				});
			}
		},
		async saveDataToSavedState() {
			try {
				let id = this.model.id;

				let response = await this.$http.post(`SubcontractGoodReceipt/SaveDataToSavedState/${id}`);

				if (response && response.data) {
					await this.getSubcontractGoodReceipt(id);
					this.clearMethodSuratJalan()
					let requestDeliveryId = this.model.subcontractRequestDeliveryId;		
					await this.getSubcontractRequestDelivery(requestDeliveryId);
					await this.getControlCards();		
					this.goToNext(3);
				}
			} catch(error) {
				let errors = error.response.data.errors['1']
				this.toast({message: errors[0], title: 'System Error', variant: 'danger', autoHideDelay: 3000})
			}
		},
		async checkSCC(paramQr) {
			try {
				if(paramQr) this.sccCardQrCode = paramQr;
				let qrCode = encodeURIComponent(this.sccCardQrCode);
				let id = this.model.id;
				let requestDeliveryId = this.model.subcontractRequestDeliveryId;
				let response = await this.$http.get(`SubcontractGoodReceipt/ScanSCC/${id}?requestDeliveryId=${requestDeliveryId}&qrcode=${qrCode}`);
				
				console.log("function check scc goes here 1");

				if (response && response.data) {
					this.isQtyFulfilled = false;
					await this.getSubcontractGoodReceipt(id);
					this.selectedDetail = await this.getSelectedDetail(this.model.id, qrCode);		
					await this.getSubcontractGoodReceiptSuggestionDetails();
					this.selectedSccCard = this.selectedDetail.controlCard;
					this.sccCardQrCode = '';

					console.log("function check scc goes here 3");

					this.goToNext(4);
					return;
				}
			} catch(error) {
				this.sccCardQrCode = '';
				let errors = error.response.data.errors['1']
				this.toast({message: errors[0], title: 'System Error', variant: 'danger', autoHideDelay: 3000})
				this.$nextTick(() => {
					this.focusInput(this, "fieldset-control-card-scc");
				});
			}
		},
		async getSelectedDetail(id, qrCode) {
			try {
				let response = await this.$http.get(`SubcontractGoodReceipt/GetSelectedDetail/${id}?cardNumber=${qrCode}`);

				if(response && response.data) {
					console.log("response", response);
					return response.data;
				}

			} catch(error) {
				this.sccCardQrCode = '';
				let errors = error.response.data.errors['1']
				this.toast({message: errors[0], title: 'System Error', variant: 'danger', autoHideDelay: 3000})
				this.$nextTick(() => {
					this.focusInput(this, "fieldset-control-card-scc");
				});
			}
			
		},
		async switchCard() {
			try {
				let qrCode = encodeURIComponent(this.pccCardQrCode);
				let id = this.selectedDetail.id;

				//let message = "Data Suggestion akan digenerate ulang, Yakin ingin melanjutkan?"
				//if(!await this.showPopupWithMessage(message)) return;
				
				let response = await this.$http.post(`SubcontractGoodReceipt/SwitchCard/${id}?qrcode=${qrCode}`);

				if (response && response.data) {
					this.pccCardQrCode = '';
					await this.getSubcontractGoodReceiptSuggestionDetails()
				}
			} catch(error) {
				this.pccCardQrCode = '';
				let errors = error.response.data.errors['1']
				this.toast({message: errors[0], title: 'System Error', variant: 'danger', autoHideDelay: 3000})
				this.$nextTick(() => {
					this.focusInput(this, "fieldset-control-card-pcc");
				});
			}
		},
		async FinishSubconGR() {
			try {
				let id = this.model.id;
				let detailId = this.selectedDetail.id;

				let message = "Yakin Ingin Menyelesaikan SubContract Good Receipt?"
				if(!await this.showPopupWithMessage(message)) return;

				let response = await this.$http.post(`SubcontractGoodReceipt/FinishSubconGR/${id}/${detailId}`);
				if(response && response.data) {
					var result = response.data;
					this.selectedDetail = {};
					this.subcontractGoodReceiptSuggestionDetails = [];
					this.selectedSccCard = {};
					this.sccCardQrCode = '';
					await this.getControlCards();
					if(result.isComplete == true) {
						this.subcontractRequestDeliveryQrCode = '';
						this.getSubcontractRequestDeliverys();
						this.createData();
						this.goToNext(1);
					} else {
						this.goToNext(3);
					}
				}
			} catch(error) {
				let errors = error.response.data.errors['1'];
				this.toast({message: errors[0], title: 'System Error', variant: 'danger', autoHideDelay: 3000});
			}
		},
		showPopupWithMessage : async function(message) {
			const msg = this.$createElement;
			let msgNode = '';
			let result = false;
			msgNode = msg('div', { domProps: { innerHTML: '<p>'+message+'</p>' } })
			await this.$bvModal.msgBoxConfirm([msgNode], {
				title: 'Alert',
				size: 'sm',
				buttonSize: 'sm',
				okVariant: 'success',
				cancelVariant: 'secondary',
				okTitle: 'Yes',
				cancelTitle: 'No',
				footerClass: 'p-2',
				hideHeaderClose: false,
				centered: true
			}).then(e=>{
				if(e){
					result = true;
				}
			});
			return result;
		},
		createData() {
			SubcontractGoodReceipt.createData(this).then(result => {
				if (result != null) {
					if (result.id != null && result.id != "") {
						let createRoute = 'subcontractgoodreceiptscan';
						this.$router.push({ name: createRoute, params : { id: result.id } });
					}
				}
			}).catch(error => {
				
			})
		},
		checkIsSubcontractRequestDeliveryDisabled(item) {
			// TODO: put your logic here
			return false;
		},
		async scanSuratJalan() {
			if(!this.suratJalanScanner) {
				let errMsg = 'Surat Jalan Wajib di isi';
				this.toast({message: errMsg, title: 'System Error', variant: 'danger', autoHideDelay: 3000})
				this.$nextTick(() => {
					this.focusInput(this, "fieldset-surat-jalan");
				});
				return;
			}

			this.model.suratJalan = this.suratJalanScanner;
			this.updateData();
			await this.getSubcontractGoodReceipt(this.model.id);
		},
		goToNext(page, item) {
			this.scanPageIndex = page;
			console.log("current page index", page);
			if(page == 1) {
				this.$nextTick(() => {
					this.focusInput(this, "fieldset-subcontract-request-delivery")
				});
			}
			if(page == 2) {
				console.log("surat jalan before", this.suratJalanScanner);
				if(item == 'back') this.clearMethodSuratJalan();
				this.$nextTick(() => {
					this.focusInput(this, "fieldset-surat-jalan");
				});
				console.log("surat jalan after", this.suratJalanScanner);
				return;
			}
			if(page == 3) {
				if(item == 'back') this.sccCardQrCode = ''
				this.$nextTick(() => {
					this.focusInput(this, "fieldset-control-card-scc");
				});
			}

			// if(page == 3) {
			// 	this.model.subcontractRequestDelivery = item;
			// 	this.model.subcontractRequestDeliveryId = item.id;
			// 	this.parentLabelInfo = 'Subcontract Request Delivery Number';
			// 	this.parentValueInfo = item.requestDeliveryNumber;
			// 	this.updateData().then((result) => {
			// 		let data = {};
			// 		let qrCode = encodeURIComponent(item.requestDeliveryNumber);
			// 		let this_ = this;
			// 		this.$http.post('SubcontractGoodReceipt/PopulateDetail/' + this.model.id + '/' + qrCode , data
			// 		).then(async function(response){
			// 			this_.scanPageIndex = page;
			// 		})
			// 		.catch(error => {
			// 			this_.$store.dispatch('addErrorMessageGlobal', error);
			// 			return;
			// 		});
			// 		this.scanPageIndex = page;
			// 	});
			// 	return;
			// }

			// if(page == 4) {
			// 	this.SubcontractGoodReceiptId = item.id;
			// 	this.modelSubcontractGoodReceipt = item;
			// 	this.isShowPopupSubcontractGoodReceipt = true;
			// 	return;
			// }

		},
	},
	beforeMount() {
		this.filterSubcontractGoodReceipt = new SubcontractGoodReceiptFilter();
		this.filterSubcontractGoodReceiptDetail = new SubcontractGoodReceiptDetailFilter();
		this.filterSubcontractGoodReceiptSuggestionDetail = new SubcontractGoodReceiptSuggestionDetailFilter();
		//this.getSubcontractGoodReceipts();
		//this.getControlCards();
		//this.getSubcontractGoodReceiptDetails();
		//this.getSubcontractRequestDeliverys();
		//this.getDocumentStatuss();
	},
	async mounted(){
		let id = this.$route.params.id;
		if (id != '' && id != null && id != undefined) {
			this.modelId = id;
			this.getSubcontractGoodReceipt(id);
		}
		this.$nextTick(() => {
			this.getSubcontractRequestDeliverys();
			window.addEventListener('resize', this.displayFilter);
			this.displayFilter();
		});
	},
	computed: {
	},
	watch : {
		scanPageIndex() {
			this.hideToast();
		},
		subcontractRequestDeliveryQrCode(newValue) {
			this.getSubcontractRequestDeliverys(newValue)
		},
		// sccCardQrCode : async function(newValue) {
		// 	await this.getControlCards(newValue);
		// },
	},
}
</script>
